import React from "react";


export default function SummaryCard({ label, value, color }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-3 px-1 rounded-xl bg-white border border-gray-100"
      style={{ boxShadow: "0 1px 6px rgba(0,0,0,0.07)" }}
    >
      <span className="text-[10px] text-gray-400 text-center mb-1 leading-tight">
        {label}
      </span>
      <span className="text-lg font-bold" style={{ color }}>
        {value} 
      </span>
    </div>
  );
}